import type { TextStyle, ViewStyle } from 'react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { typography } from '@shared/config/typographyConfig';

export const DOCUMENTS_STATUS_BADGE_STYLE: ViewStyle = { borderWidth: 0 };

export const DOCUMENTS_STATUS_BADGE_TEXT_STYLE: TextStyle = {
    fontSize: typography.fontSize.sm,
    fontWeight: '700',
};

export const DOCUMENTS_UPLOAD_LABEL_STYLE: TextStyle = {
    fontSize: typography.fontSize.base,
    fontWeight: '500',
};

export const DOCUMENTS_UPLOAD_LABEL_ENABLED_STYLE: TextStyle = {
    ...DOCUMENTS_UPLOAD_LABEL_STYLE,
    color: colorPalette.white,
};
